import { ADDITIONAL_PRIZE_TIERS, IPrizeTier, PRIZE_TIERS } from "constants/LottoPrizeValues";

export interface IPrizeTableEntry {
  match: number;
  matchBonus: number;
  alternativeMatch?: number;
  alternativeMatchBonus?: number;
  requireBoost: boolean;
  prizeTier: IPrizeTier;
}

export const prizeTableByPlanType = {
  PREMIUM: {
    prizes: [
      { match: 4, matchBonus: 1, requireBoost: true, prizeTier: PRIZE_TIERS['DAYMAKER+ prize'], },
      { match: 4, matchBonus: 1, requireBoost: false, prizeTier: PRIZE_TIERS['DAYMAKER prize'], },
      { match: 4, matchBonus: 0, requireBoost: false, prizeTier: PRIZE_TIERS['Diamond prize'], },
      { match: 3, matchBonus: 1, requireBoost: false, prizeTier: PRIZE_TIERS['Platinum prize'], },
      { match: 3, matchBonus: 0, requireBoost: false, prizeTier: PRIZE_TIERS['Gold prize'], },
      { match: 2, matchBonus: 1, requireBoost: false, prizeTier: PRIZE_TIERS['Silver prize'], },
      { match: 2, matchBonus: 0, requireBoost: false, prizeTier: PRIZE_TIERS['Bronze prize'], },
      { match: 1, matchBonus: 1, requireBoost: false, prizeTier: ADDITIONAL_PRIZE_TIERS.DAYMADE_CREDIT, },
      { match: 1, matchBonus: 0, requireBoost: false, prizeTier: ADDITIONAL_PRIZE_TIERS.DAYMADE_PREMIUM_ENTRY, },
      { match: 0, matchBonus: 1, requireBoost: false, prizeTier: ADDITIONAL_PRIZE_TIERS.DAYMADE_TOKEN, },
    ],
    initialPrizeCountToShow: 7
  },
  LITE: {
    prizes: [
      { match: 4, matchBonus: 1, requireBoost: true, prizeTier: PRIZE_TIERS['DAYMAKER+ prize'], },
      { match: 4, matchBonus: 1, requireBoost: false, prizeTier: PRIZE_TIERS['Diamond prize'], },
      { match: 4, matchBonus: 0, requireBoost: false, prizeTier: PRIZE_TIERS['Platinum prize'], },
      { match: 3, matchBonus: 1, requireBoost: false, prizeTier: PRIZE_TIERS['Gold prize'], },
      { match: 3, matchBonus: 0, requireBoost: false, prizeTier: PRIZE_TIERS['Silver prize'], },
      { match: 2, matchBonus: 1, requireBoost: false, prizeTier: PRIZE_TIERS['Bronze prize'], },
      { match: 2, matchBonus: 0, requireBoost: false, prizeTier: ADDITIONAL_PRIZE_TIERS.DAYMADE_CREDIT, },
      { match: 1, matchBonus: 1, requireBoost: false, prizeTier: ADDITIONAL_PRIZE_TIERS.DAYMADE_PREMIUM_ENTRY, },
      { match: 1, matchBonus: 0, alternativeMatch: 0, alternativeMatchBonus: 1,  requireBoost: false, prizeTier: ADDITIONAL_PRIZE_TIERS.DAYMADE_TOKEN, },
    ],
    initialPrizeCountToShow: 6
  },
  POSTAL: {
    prizes: [] as ({ match: number, matchBonus: number, alternativeMatch?: number, alterativeMatchBonus?: number, requireBoost: boolean, prizeTier: typeof PRIZE_TIERS['DAYMAKER prize']}[]),
    initialPrizeCountToShow: 0
  }
} as const